export const DELETE = "delete";

export const PASSCODE_ITEMS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  DELETE,
  "0",
];
